import { ITextfieldValueDisp } from "../../interfaces/ITextfieldValueDisp";

import { TextField } from "@goodgamestudios/createjs-utilities";

export class BasicTextfieldValueContainer implements ITextfieldValueDisp {
    private textf: TextField;

    constructor(target: TextField) {
        this.textf = target;
    }

    public getTextfield(): TextField {
        return this.textf;
    }
}
